import { render, staticRenderFns } from "./BCXTagSelectAdd.vue?vue&type=template&id=09a7a891&scoped=true"
import script from "./BCXTagSelectAdd.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXTagSelectAdd.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXTagSelectAdd.vue?vue&type=style&index=0&id=09a7a891&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a7a891",
  null
  
)

export default component.exports